import React from "react"

import {
    communityTypes,
    communityStatuses
} from "../../../../config/application-definitions"

import ImageSelector from "../../../common/ImageSelector"

const CommunityEditItemDetails = ({
    name,
    description,
    status,
    privacy,
    imageUrl,
    openFeed,
    imagePreviewURL,
    onEventChange,
    onValueChange,
    onImageChange
}) => (
    <div className="widget">
        <div id="community-detail-content" className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-headline" />Name
            </h3>
            <input
                name="name"
                type="text"
                className="form-control"
                placeholder="Name"
                value={name}
                onChange={onEventChange}
            />
            <h3>
                <span className="icon icon-description" />Description
            </h3>
            <textarea
                name="description"
                className="form-control"
                placeholder="Description"
                value={description}
                onChange={onEventChange}
            />
            <h3>
                <span className="icon icon-status" />Status
            </h3>
            <select
                name="status"
                className="form-control"
                value={status || "Active"}
                onChange={onEventChange}
            >
                {communityStatuses.map(value => (
                    <option value={value} key={value}>
                        {value}
                    </option>
                ))}
            </select>
            <h3>
                <span className="icon icon-status" />Type
            </h3>
            <select
                name="privacy"
                className="form-control"
                value={privacy || "public"}
                onChange={onEventChange}
            >
                {Object.keys(communityTypes).map(value => (
                    <option value={value} key={value}>
                        {communityTypes[value]}
                    </option>
                ))}
            </select>
            {privacy === "inviteonly" && (
                <div>
                    <h3>
                        <span className="icon icon-article" />Open feed
                    </h3>
                    <label>
                        <input
                            name="open_feed"
                            type="checkbox"
                            checked={openFeed}
                            onChange={onEventChange}
                        />
                        &nbsp;Open feed
                    </label>
                </div>
            )}
            <h3>
                <span className="icon icon-heroimg" />Hero image
            </h3>
            <ImageSelector
                onImageSelect={onImageChange}
                imageUrl={
                    imagePreviewURL !== undefined ? imagePreviewURL : imageUrl
                }
            />
        </div>
    </div>
)

export default CommunityEditItemDetails
